import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --ralph-image-height: calc(270rem / var(--default-rem-px-count));
    }

    .ralph-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding);
      max-width: 100%;
    }

    .ralph-header {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--between-row-padding);
    }

    .scroll-buttons {
      display: none;
      height: calc(40rem / var(--default-rem-px-count));
      width: calc(40rem / var(--default-rem-px-count));
      cursor: pointer;
      align-items: center;
      justify-content: center;
    }

    .scroll-buttons svg {
      height: calc(16rem / var(--default-rem-px-count));
      width: calc(8rem / var(--default-rem-px-count));
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
      display: flex;
      flex-wrap: nowrap;
      gap: var(--between-column-padding-lg);
      overflow-x: scroll;
      /* Thin dark-theme scrollbar, scoped to the strip so the override
         cannot leak into descendant elements. */
      scrollbar-width: thin;
      scrollbar-color: #ffffff #333333;
    }

    .images::-webkit-scrollbar {
      height: 3px;
      background-color: #333333;
    }

    .images::-webkit-scrollbar-track {
      background-color: #333333;
    }

    .images::-webkit-scrollbar-thumb {
      background-color: #ffffff;
      border: none;
    }

    .images.scrollable {
      /* Distance from the captions down to the scrollbar track. */
      padding-bottom: calc(30rem / var(--default-rem-px-count));
    }

    .image > img {
      display: block;
      margin-bottom: var(--between-row-padding);
      height: var(--ralph-image-height);
    }

    /* Not a caption cluster: a stacked industry/name pair with no divider. */
    .project-label {
      display: flex;
      flex-direction: column;
    }

    .project-label h3 {
      font-size: var(--fs-title);
      line-height: var(--lh-title);
      letter-spacing: var(--ls-title);
      padding-top: calc(8rem / var(--default-rem-px-count));
    }

    .project-label > span > p {
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      margin: 0;
    }

    @media (min-width: 600px) {
      .ralph-header {
        grid-column: 2 / 14;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        /* Figma shows ~50px from the header down to the image strip. */
        padding-bottom: calc(50rem / var(--default-rem-px-count));
      }

      /* cta-text sets align-self on its own :host; only a rule from out here
         lets it join the baseline group. */
      .ralph-header > cta-text {
        align-self: baseline;
      }

      .images {
        grid-column: 2 / 14;
      }

      .images.scrollable {
        padding-bottom: calc(50rem / var(--default-rem-px-count));
      }

      /* Both arrows sit in their own row above the strip, right-aligned to
         the strip edge; the column gutter separates the pair. */
      .scroll-buttons {
        display: flex;
        grid-row: 3;
        justify-self: end;
      }

      .left-arrow {
        grid-column: 2 / 13;
        transform: rotate(180deg);
      }

      .right-arrow {
        grid-column: 13 / 14;
      }
    }

    @media (min-width: 1024px) {
      :host {
        --ralph-image-height: calc(400rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1200px) {
      :host {
        --ralph-image-height: calc(480rem / var(--default-rem-px-count));
      }
    }
  `,
];
